// removed by extract-text-webpack-plugin
module.exports = {"iron":"#d3d3d3","shark":"#2a2a32","footer":"footer_footer_2e6Pz","container":"footer_container_79lLP","section-top":"footer_section-top_1jDQ0","section-bottom":"footer_section-bottom_2L_6M","contact":"footer_contact_1iNpJ","follow":"footer_follow_3flSt","icons":"footer_icons_3JMeN","link":"footer_link_TMjIH","copyright":"footer_copyright_R97Uw","menu":"footer_menu_3-7n3","wechatQR":"footer_wechatQR_202J6","disclaimer":"footer_disclaimer_3lWPj","lato-oversize":"footer_lato-oversize_3UNLE lato-oversize","lato-subtitle":"footer_lato-subtitle_HGM0J lato-subtitle","icon":"footer_icon_1dvMn"};


//////////////////
// WEBPACK FOOTER
// ./src/component/footer/footer.css
// module id = 375
// module chunks = 4